import { ScrollView, View } from "react-native";
import { Slot } from "expo-router";

const IntegrationsLayout = () => {
  return (
    <ScrollView className="flex-1 bg-gray-50 sm:p-6">
      <View className="p-4 md:p-6 lg:p-8 max-w-4xl mx-auto w-full">
        <Slot />
      </View>
    </ScrollView>
  );
};

export default IntegrationsLayout;
